"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var TextListComponent = function TextListComponent(props) {
  var _a;
  var _b = props.data,
    data = _b === void 0 ? [] : _b,
    _c = props.as,
    Tag = _c === void 0 ? 'ul' : _c,
    // eslint-disable-line
    _d = props.moreLabel,
    // eslint-disable-line
    moreLabel = _d === void 0 ? '了解更多' : _d,
    moreLink = props.moreLink,
    moreProps = props.moreProps,
    _e = props.size,
    size = _e === void 0 ? 'normal' : _e,
    type = props.type;
  var moreLinkComponent = moreLink || moreProps ? react_1["default"].createElement("li", null, react_1["default"].createElement("a", __assign({
    href: moreLink,
    className: "odc-text-list-more-link",
    target: "_blank"
  }, moreProps), moreLabel)) : null;
  return react_1["default"].createElement(Tag, __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-text-list', "odc-text-".concat(size), (_a = {}, _a["odc-text-".concat(type)] = type, _a)),
    supportAllEvents: true
  }, TextListComponent)), data.map(function (item, i) {
    return react_1["default"].createElement("li", {
      key: "tips_line".concat(i)
    }, item);
  }), moreLinkComponent);
};
(0, spaui_utils_1.setComponentMark)(TextListComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(TextListComponent);